import {
  resolveXlsxFileName,
  triggerBlobDownload,
} from '../../utils/http/responseHelpers';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import qs from 'qs';
import { Status } from '../../models/common/Status';
import { apiClientWithApi } from '../../utils/http';
import { DispensarizationsReportParameters } from '../../hooks/features/useDispensarizationsReportPopup/constants';
import { RootState } from '../store';

export interface ReportState {
  status: Status;
}

export interface DispensarizationsReportRequest {
  'Filter.From': string;
  'Filter.To': string;
  'Filter.ClinicIds'?: string[];
  'Filter.BatchIds'?: string[];
  'Filter.Result'?: string[];
  'Filter.States'?: string[];
  'Filter.AttemptStates'?: string[];
  'Filter.TextSearch'?: string;
}

const initialState: ReportState = {
  status: {
    responseLoading: false,
    responseError: null,
    requestSuccess: null,
    requestError: null,
  },
};

export const getDispensarizationsReport = createAsyncThunk(
  'Dispensarizations/getDispensarizationsReport',
  async (request: DispensarizationsReportRequest, { rejectWithValue }) => {
    try {
      const params = {
        [DispensarizationsReportParameters.From]: request['Filter.From'],
        [DispensarizationsReportParameters.To]: request['Filter.To'],
        [DispensarizationsReportParameters.ClinicIds]:
          request['Filter.ClinicIds'],
        [DispensarizationsReportParameters.Results]: request['Filter.Result'],
        [DispensarizationsReportParameters.BatchIds]:
          request['Filter.BatchIds'],
        'Filter.States': request['Filter.States'],
        'Filter.AttemptStates': request['Filter.AttemptStates'],
        [DispensarizationsReportParameters.TextSearch]:
          request['Filter.TextSearch'],
      };

      const response = await apiClientWithApi.get(
        'task/dispensarization/report',
        {
          params,
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: 'repeat' });
          },
          responseType: 'blob',
        },
      );

      const fileName = resolveXlsxFileName(
        response.headers['content-disposition'],
        `journal_disp_${request['Filter.From']}_${request['Filter.To']}.xlsx`,
      );
      triggerBlobDownload(new Blob([response.data]), fileName);

      return fileName;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.message);
      } else return rejectWithValue('Не удалось получить отчёт!');
    }
  },
);

export const dispensarizationsReportSlice = createSlice({
  name: 'dispensarizationsReport',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getDispensarizationsReport.pending, (state) => {
        state.status.responseLoading = true;
        state.status.responseError = null;
        return state;
      })
      .addCase(getDispensarizationsReport.fulfilled, (state, action) => {
        state.status.responseLoading = false;
        state.status.responseError = null;
        return state;
      })
      .addCase(getDispensarizationsReport.rejected, (state) => {
        state.status.responseLoading = false;
        state.status.responseError = 'Не удалось загрузить звонки';
        return state;
      });
  },
});

export default dispensarizationsReportSlice.reducer;

export const selectDispensarizationsReportLoading = (state: RootState) =>
  state.dispensarizationsReport.status.responseLoading;
